import React from 'react'
import PropTypes from 'prop-types'
import { ResponsiveIframe } from 'scripts/helpers/AppHelper'
import queryString from 'querystring'

const YoutubeHeroIframe = (props) => {
  const { src } = props
  const youtubeOptions = {
    autoplay: 1,
    rel: 0,
    showinfo: 0,
    modestbranding: 1
  }
  const youtubeOptionQueryString = queryString.stringify(youtubeOptions)
  const splittedSrc = src.split('?')

  let finalSrc = ''
  if (splittedSrc.length > 0) {
    finalSrc = `${splittedSrc[0]}?${youtubeOptionQueryString}`
  }

  return (
    <div className='article-iframe-hero'>
      <ResponsiveIframe src={ finalSrc } allowFullScreen={ true } allow="autoplay; fullscreen; encrypted-media"></ResponsiveIframe>
    </div>
  )
}
export default YoutubeHeroIframe

YoutubeHeroIframe.propTypes = {
  src: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/components/article/HeroIframe/YoutubeHeroIframe.jsx